var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.author.baseUnits),function(unit){return _c('v-chip',{key:unit.id,staticClass:"mr-1",class:{'text-decoration-line-through': !unit.valid},attrs:{"small":""}},[_vm._v(" "+_vm._s(unit.abbr)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }